import React from 'react';

export const ArrowLeftIcon = () => (
    <svg className="w-4 h-4" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 8H4" stroke="#1B1C1E" strokeLinecap="square" strokeLinejoin="round"/>
        <path d="M7.5 3.5L3 8L7.5 12.5" stroke="#1B1C1E" strokeLinecap="square"/>
    </svg>
);